import { ListTableColumn, createListTableColumns, renderBooleanIcon, ListActionButtonProps } from "sprint-common-web";

import { ContentSource } from "../../../common/types/ContentSource";
import { MovieContentSubtype } from "../../../common/types/MovieContentSubtype";
import { renderBuzzItem } from "../../common/components/BuzzItem";
import { renderShreqItem } from "../../common/components/ShreqItem";
import { renderContentSources } from "../../common/utils/renderContentSources";
import { getMovieDashboardHref } from "../../ContentRoutes";
import { AddMovieToMergeListButton } from "./buttons/AddMovieToMergeListButton";
import { ViewMovieAssetButton } from "./buttons/ViewMovieAssetButton";
import { MovieItem } from "./MovieItem";

export interface CreateMovieListingColumnsProps {
    contentType: MovieContentSubtype;
    moviesToMerge: MovieItem[];
    movieListingItems: MovieItem[];
    addMovieItemToMergeList(movie: MovieItem): void;
}

export const createMovieListingColumns = (props: CreateMovieListingColumnsProps): ListTableColumn<MovieItem>[] => {
    const { contentType, moviesToMerge, movieListingItems, addMovieItemToMergeList } = props;

    const handleAddTvSeriesToMergeList = (movie: MovieItem) => {
        addMovieItemToMergeList(movie);
    };

    return createListTableColumns<MovieItem>([
        {
            type: "link",
            key: "title",
            name: "Title",
            minWidth: 100,
            maxWidth: 280,
            isSortable: true,
            getHref: (item) => getMovieDashboardHref(item.id, contentType),
            isDisabled: (item) => item.merged || false
        },
        {
            type: "basic",
            key: "merged",
            name: "Merged",
            minWidth: 70,
            maxWidth: 70,
            isSortable: false,
            onRender: renderBooleanIcon
        },
        {
            type: "basic",
            key: "includedSources",
            name: "Source",
            minWidth: 120,
            maxWidth: 160,
            isSortable: false,
            onRender: renderContentSources
        },
        {
            type: "basic",
            key: "buzz",
            name: "Source details",
            minWidth: 200,
            maxWidth: 200,
            isSortable: false,
            onRender: (item) => {
                if (item?.includedSources.includes(ContentSource.Shreq)) return renderShreqItem(item.shreq);
                return renderBuzzItem(item?.buzz);
            }
        },
        {
            type: "buttons",
            key: "actions",
            name: "Actions",
            minWidth: 64,
            maxWidth: 96,
            buttons: [
                {
                    id: "merge",
                    isDisabled: (item) => item.merged || item.includedSources.includes(ContentSource.Shreq),
                    onItemInvoked: handleAddTvSeriesToMergeList,
                    render: (renderProps: ListActionButtonProps) =>
                        AddMovieToMergeListButton({
                            ...renderProps,
                            moviesToMerge: moviesToMerge,
                            movieList: movieListingItems
                        })
                },
                {
                    id: "viewAssets",
                    render: ViewMovieAssetButton
                }
            ]
        }
    ]);
};
